<ng-container *ngIf="data$ | async as data">
  <mat-table #table class="order-furniture-table" [dataSource]="dataSource" fusePerfectScrollbar>
    <!-- Material Select Column -->
    <ng-container matColumnDef="selected">
      <mat-header-cell *matHeaderCellDef class="max-w-16">
        <mat-checkbox
          [ngModel]="selectedAll"
          (change)="selectAll()"
          [disabled]="dataSource.data.length === 0 || !editableOrder"></mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let item" class="max-w-16">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selectedFurnitures.toggle(item.id) : null"
          [checked]="selectedFurnitures.isSelected(item.id)"
          [disabled]="!editableOrder">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Material Texture Column -->
    <ng-container matColumnDef="texture">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <ng-container *ngIf="!item.textureName && item.color; then showColor; else showTexture"> </ng-container>
        <ng-template #showColor>
          <div class="mw-texture mw-color" [ngStyle]="{ 'background-color': '#' + item.color }"></div>
        </ng-template>
        <ng-template #showTexture>
          <img
            *ngIf="item.textureName"
            class="mw-texture"
            src="{{ item.cropTextureLink }}"
            (error)="setImagePlug($event)" />
        </ng-template>
      </mat-cell>
    </ng-container>

    <!-- Material Name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <span class="h6 p-1">{{ item.name }}</span>
      </mat-cell>
    </ng-container>

    <!-- Material Article Column -->
    <ng-container matColumnDef="article">
      <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.article }}
      </mat-cell>
    </ng-container>

    <!-- Material Size Column -->
    <ng-container matColumnDef="size">
      <mat-header-cell *matHeaderCellDef i18n>Габариты</mat-header-cell>
      <mat-cell *matCellDef="let item"> {{ item.width }}&times;{{ item.height }} </mat-cell>
    </ng-container>

    <!-- Material Count Column -->
    <ng-container matColumnDef="count">
      <mat-header-cell *matHeaderCellDef i18n>Количество</mat-header-cell>
      <mat-cell class="flex items-center" *matCellDef="let item">
        <ng-container *ngIf="item.roundMode === 0; else roundTemplate">
          <mat-form-field appearance="outline" class="w-full">
            <input
              required
              #countInput="ngModel"
              type="number"
              matInput
              [(ngModel)]="item.count"
              value="value"
              (ngModelChange)="countInput.valid ? formChange$.next(item) : null"
              [disabled]="!editableOrder" />
          </mat-form-field>
        </ng-container>
        <ng-template #roundTemplate>
          <mat-form-field
            appearance="outline"
            class="w-full"
            [matTooltipDisabled]="!countInput.hasError('multipleOfNumber')"
            i18n-matTooltip
            matTooltip="Количество должно быть кратным {{
              countInput.hasError('multipleOfNumber') ? countInput.getError('multipleOfNumber').number : 1
            }}">
            <input
              required
              type="number"
              #countInput="ngModel"
              cslMultipleOfNumber
              [num]="item.roundNumber"
              matInput
              [(ngModel)]="item.count"
              value="value"
              (ngModelChange)="countInput.valid ? formChange$.next(item) : null"
              [disabled]="!editableOrder" />
          </mat-form-field>
        </ng-template>
      </mat-cell>
    </ng-container>

    <!-- Material Measure Column -->
    <ng-container matColumnDef="measure">
      <mat-header-cell *matHeaderCellDef i18n>Ед. изм.</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.measureName }}
      </mat-cell>
    </ng-container>

    <!-- Material Price Column -->
    <ng-container matColumnDef="price">
      <mat-header-cell *matHeaderCellDef i18n>Цена</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.price | formatNumber : 2 | formatCurrency }}
      </mat-cell>
    </ng-container>

    <!-- Material Cost Column -->
    <ng-container matColumnDef="cost">
      <mat-header-cell *matHeaderCellDef i18n>Стоимость</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.price * item.count | formatNumber : 2 | formatCurrency }}
      </mat-cell>
    </ng-container>

    <!-- Material Delete Column -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef
        ><button mat-icon-button [matMenuTriggerFor]="delete"><mat-icon>more_vert</mat-icon></button
        ><mat-menu #delete="matMenu">
          <button
            mat-menu-item
            i18n
            (click)="deleteFurnitures()"
            [disabled]="!editableOrder || dataSource.data.length === 0"
            >Удалить выбранную фурнитуру</button
          >
        </mat-menu></mat-header-cell
      >
      <mat-cell *matCellDef="let item">
        <button mat-icon-button (click)="deleteFurniture(item)" [disabled]="!editableOrder">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <!-- <mat-paginator #paginator (page)="page$.next({ pageIndex: $event.pageIndex, pageSize: $event.pageSize })"
            [length]="data.result.totalCount" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
        </mat-paginator> -->
</ng-container>
